// Which layout the clicker uses: the touch layout (one column, bottom tab bar,
// sheets) or the desktop shell (side rails, collapse tabs, keyboard hint).
//
// Width alone used to decide it, at 768px. That put every tablet on the desktop
// shell, a layout built for a mouse and a laptop beside the projector, while
// the person holding the tablet is using it the way they'd use a phone, as a
// clicker in their hand. So a touch-first device gets the touch layout at any
// width, and the 768px split now only decides it for devices with a mouse.
//
// "Touch-first" is the PRIMARY input: no hover and a coarse pointer. A
// touchscreen laptop reports its trackpad (hover, fine), so it stays on
// desktop. Phones and tablets, including an iPad, report hover: none.
//
// Both strings are used in CSS (`@media ${MOBILE_QUERY}`) and in matchMedia, and
// DESKTOP_QUERY is the exact complement of MOBILE_QUERY, so no width can match
// both or neither.
export const MOBILE_QUERY =
  "(max-width: 767px), (hover: none) and (pointer: coarse)";

export const DESKTOP_QUERY =
  "(min-width: 768px) and (hover: hover), (min-width: 768px) and (pointer: fine), (min-width: 768px) and (pointer: none)";

/** DESKTOP_QUERY narrowed by one more condition, e.g. `(max-height: 420px)`.
 *  A media query list is OR-ed, so the extra condition has to be added to
 *  every branch rather than appended once. */
export const desktopQueryAnd = (condition: string) =>
  DESKTOP_QUERY.split(", ")
    .map((branch) => `${branch} and ${condition}`)
    .join(", ");

// Within the touch layout, the two shapes that get a view of their own (see
// the slide views in pages/controller.tsx):

/** A tablet on its side: room for the slide AND the next one beside it. */
export const PRESENTER_VIEW_QUERY =
  "(orientation: landscape) and (min-width: 900px) and (min-height: 600px)";

/** A phone on its side. Too short for a header, a slide and PREV/NEXT, so the
 *  slide takes the whole screen. 500px clears the tallest phones in landscape
 *  and stays well under the shortest tablet. */
export const PHONE_LANDSCAPE_QUERY =
  "(orientation: landscape) and (max-height: 500px)";
